import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Notificar } from "../../Comunes/Notificador";


function ModificarMotivoLiquidacionModal({
    CuentasAtrasadas,
    actualizarCuentaPorCobrar,
}) {
    const [show, setShow] = useState(false);
    const [CuentasAtrasadasLocal, setCuentasAtrasadasLocal] =
        useState(CuentasAtrasadas);


    const handleClose = () => {
        setCuentasAtrasadasLocal(CuentasAtrasadas);
        setShow(false);
    };

    const handleShow = () => { setShow(true);}

    const manejarCambioDeSaldoCuentaACobrar = e => {
        let { name, value } = e.target;
        // Reemplaza las comas con puntos
        value = value.replace(/,/g, ".");
        if (!value || value.match(/^\d{0,20}(\.\d{0,2})?$/)) {
            setCuentasAtrasadasLocal({
                ...CuentasAtrasadasLocal,
                [name]: value,
                tipoAccion: "M",
                diasAtrasoPropuesto: CuentasAtrasadasLocal.diasAtrasoPropuesto ?? CuentasAtrasadasLocal.diasAtrasoReportado,
            });
        }
    }


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!datosValidos()) {
            return;
        }
        let cuenta = CuentasAtrasadasLocal;

        setCuentasAtrasadasLocal({
            ...CuentasAtrasadasLocal,
            tipoMoneda: cuenta.tipoMoneda,
            catalogo: cuenta.catalogo,
            tipoAccion: "M",
            diasAtrasoPropuesto: cuenta.diasAtrasoPropuesto ?? CuentasAtrasadasLocal.diasAtrasoReportado,
            saldoCuentaPorCobrarPropuesto:  cuenta.saldoCuentaPorCobrarPropuesto ?? CuentasAtrasadasLocal.saldoCuentaPorCobrarReportado
        });
        
        actualizarCuentaPorCobrar(CuentasAtrasadasLocal);

        
        handleClose();
    };

    function datosValidos() {

        if (
            Number(CuentasAtrasadasLocal.saldoCuentaPorCobrarPropuesto ?? CuentasAtrasadasLocal.saldoCuentaPorCobrarReportado) ===
            Number(CuentasAtrasadasLocal.saldoCuentaPorCobrarReportado) &&
            Number(CuentasAtrasadasLocal.diasAtrasoPropuesto ?? CuentasAtrasadasLocal.diasAtrasoReportado) ===
            Number(CuentasAtrasadasLocal.diasAtrasoReportado)
        ) {
            Notificar(
                "error",
                "Los datos propuestos son los mismos datos reportados por la SUGEF."
            );
            return false;
        }

        return true;
    }


    return (
        <>
            <button
                className="btn btn-outline-primary btn-xs"
                title="Modificar motivo de liqidación"
                onClick={handleShow}
            >
                <i className="fas fa-edit"></i>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modificar Días de atraso y Saldo Cuentas por Cobrar</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <div>
                            <div className="form-group">
                                <label htmlFor="saldoCuentaPorCobrarPropuesto">
                                    Saldo Cuenta por cobrar propuesto
                                </label>
                                <Form.Control
                                    type="text"
                                    className="form-control"
                                    name="saldoCuentaPorCobrarPropuesto"
                                    id="saldoCuentaPorCobrarPropuesto"
                                    value={CuentasAtrasadasLocal.saldoCuentaPorCobrarPropuesto ?? CuentasAtrasadasLocal.saldoCuentaPorCobrarReportado}
                                    onChange={manejarCambioDeSaldoCuentaACobrar}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="diasAtrasoPropuesto">
                                    Días de atraso propuesto
                                </label>
                                <Form.Control
                                    type="number"
                                    className="form-control"
                                    name="diasAtrasoPropuesto"
                                    id="diasAtrasoPropuesto"
                                    value={CuentasAtrasadasLocal.diasAtrasoPropuesto ?? CuentasAtrasadasLocal.diasAtrasoReportado}
                                    onChange={(e) =>
                                        setCuentasAtrasadasLocal({
                                            ...CuentasAtrasadasLocal,
                                            diasAtrasoPropuesto: e.target.value,
                                            tipoAccion: "M",
                                            saldoCuentaPorCobrarPropuesto:  CuentasAtrasadasLocal.saldoCuentaPorCobrarPropuesto ?? CuentasAtrasadasLocal.saldoCuentaPorCobrarReportado
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" type="submit">
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}

export default ModificarMotivoLiquidacionModal;
